export default "__VITE_ASSET__CctueT2e__"